import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	noOptionsMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noOptionsPrimaryMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noOptionsSecondaryMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	noOptionsMessage: {
		id: 'jql-builder-basic-picker.async-select.select.no-options-message.no-options-message',
		defaultMessage: 'No matches found',
		description: 'The text for when no matches are found in dropdown',
	},
	noOptionsPrimaryMessage: {
		id: 'jql-builder-basic-picker.async-select.select.no-options-message.no-options-primary-message',
		defaultMessage: "We couldn't find what you're looking for",
		description:
			'The text for when no matches are found in dropdown when a user tries to search for an option',
	},
	noOptionsSecondaryMessage: {
		id: 'jql-builder-basic-picker.async-select.select.no-options-message.no-options-secondary-message',
		defaultMessage: 'Try using different search terms.',
		description:
			'Helpful tip for when no matches are found in dropdown, prompting user to try a different search',
	},
});
export default messages;
